module.exports = __webpack_public_path__ + "img/map.609434bf.png";